import { useId } from "react"

import type { SX } from "../../theme"
import { RadioGroup, type RadioGroupProps } from "../Radio"
import { FormField } from "./FormField"

export interface FormRadioGroupProps<V extends string>
  extends RadioGroupProps<V> {
  error?: boolean | string
  description?: string
  sx?: SX
  label?: string
}

export function FormRadioGroup<V extends string>(
  props: FormRadioGroupProps<V>,
) {
  const { sx, error, description, disabled, label, ...radioGroupProps } = props

  const id = useId()

  return (
    <FormField
      id={id}
      sx={sx}
      error={error}
      description={description}
      label={label}
    >
      <RadioGroup disabled={disabled} id={id} {...radioGroupProps} />
    </FormField>
  )
}
